import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Shapes } from '../../models/entities';

import Toolbar from '../../components/toolbars/PaginationToolbar';
import { updatePage, updatePageSize } from '../../actions/pagination';

class ToolbarContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangePageSize = this.onChangePageSize.bind(this);
  }

  onChangePage(pageNumber) {
    const { updatePage: pageUpdater, onPaginationChange } = this.props;
    pageUpdater(pageNumber);
    return onPaginationChange().catch((error) => toast.error(error.message));
  }

  onChangePageSize(event) {
    const { updatePageSize: pageSizeUpdater, onPaginationChange } = this.props;
    pageSizeUpdater(parseInt(event.target.value, 10));
    return onPaginationChange().catch((error) => toast.error(error.message));
  }

  render() {
    const { pagination, children } = this.props;
    return (
      <Toolbar
        pagination={pagination}
        onChangePage={this.onChangePage}
        onChangePageSize={this.onChangePageSize}
      >
        {children}
      </Toolbar>
    );
  }
}

ToolbarContainer.propTypes = {
  updatePage: PropTypes.func.isRequired,
  updatePageSize: PropTypes.func.isRequired,
  onPaginationChange: PropTypes.func.isRequired,
  pagination: Shapes.PAGINATION.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ToolbarContainer.defaultProps = {
  children: undefined,
};

export default connect(null, { updatePage, updatePageSize })(ToolbarContainer);
